// 45 min sessions need a 15 min start-time grid; every other duration stays on 30 min.
export const get_time_interval_for_duration = (duration) => (Number(duration) === 45 ? 15 : 30);
